<template>
  <a-card title="批量创建模板" >
    <a-form :label-col="{ span: 4 }" :model="batchCommonParams" style="margin: 10px auto;" >
      <div >
        <!-- 通用参数 -->
        <div style="width: 800px;margin: 10px;">
          <p class="form-section-title">通用参数</p>
          <a-form-item required label="工具">
            <a-select
            :allowClear="true"
              style="width: 100px;"
              v-model:value="batchCommonParams.tool_id"
              :options="ToolIDOptions"
              placeholder="工具"
            />
          </a-form-item>
          <a-form-item required label="国家地区" name="region_code">
            <a-input-group compact style="width: 300px; display: flex;">
              <a-select
                style="width: 120px"
                v-model:value="batchCommonParams.region_code"
                :options="NationCodes"
                placeholder="国家地区"
              />
              <a-input style="width: 80px" placeholder="国家地区" v-model:value="batchCommonParams.region_code" />
            </a-input-group>
            <p>*需要展示模版的国家地区 </p>
          </a-form-item>
          
          <a-form-item required label="所属 Tab" name="tab_id">
            <a-space>
              <a-select
                v-if="optionTabs.length > 0 || batchCommonParams.tab_id"
                style="width: 160px;"
                v-model:value="batchCommonParams.tab_id"
                :options="optionTabs"
                placeholder="Tab 名称"
              />
              <a-button @click="getBatchOptionTabs" type="primary" >加载 Tab</a-button>
              <a-button
                type="primary"
                @click="searchBatchOptionTabs"
                shape="circle"
              >
                <template #icon><SearchOutlined /></template>
              </a-button>
            </a-space>
          </a-form-item>
          
          <p class="form-section-title">生成参数</p>
          <a-form-item  label="跳转地址"  name="redirect_url">
            <a-input placeholder="redirect_url" v-model:value="batchCommonParams.redirect_url" />
            <a-alert message="如有则「忽略」下面的参数" type="warning" show-icon  />
          </a-form-item>

          <a-form-item required label="任务流类型"  name="style_id">
            <a-select
              v-model:value="batchCommonParams.style_id"
              :options="TaskStyleGroupOptions"
              placeholder="StyleID"
            />
          </a-form-item>

          <a-form-item  label="任务子类型"  name="sub_type">
            <a-select
              v-model:value="batchCommonParams.sub_type"
              :options="SubTypeOptions"
              placeholder="SubType"
            />
          </a-form-item>
          <a-form-item label="涂抹" name="spreadable">
            <a-select
                style="width: 80px;"
                v-model:value="batchCommonParams.spreadable"
                :options="spreadableOptions"
                placeholder="spreadable"
              />
          </a-form-item>
          <a-form-item label="默认提示词" name="prompt">
            <a-textarea :rows="3" placeholder="prompt" v-model:value="batchCommonParams.prompt" />
          </a-form-item>
          
          <a-form-item label="性别" name="typeid">
            <a-select
                style="width: 80px;"
                v-model:value="batchCommonParams.typeid"
                :options="[
                  {
                    value: '',
                    label: '所有'
                  },
                  {
                    value: 'female',
                    label: '女性'
                  },
                  {
                    value: 'male',
                    label: '男性'
                  },
                ]"
                placeholder="typeid"
              />
          </a-form-item>
          <template v-if="batchCommonParams.tool_id == 'clothes'">
            <a-form-item label="分类名称" name="category_name">
              <a-select
                  style="width: 100px;"
                  v-model:value="batchCommonParams.category_name"
                  :options="categoryOptions"
                  placeholder="category_name"
                />
              <p>*仅换装需要填写</p>
            </a-form-item>
          </template>
        
          <a-form-item label="Position" name="position" v-if="false">
          <a-input placeholder="position" v-model:value="batchCommonParams.position" />
        </a-form-item>
        <a-form-item label="扩展参数" name="value" v-if="false">
          <a-textarea placeholder="extend params" v-model:value="batchCommonParams.value" />
        </a-form-item>
        <a-form-item label="模板动画位置" name="blind_position" v-if="false">
          <a-select
              v-model:value="batchCommonParams.blind_position"
              :options="[{
                label: '编辑器',
                value: 'editor',
              },{
                label: '首页',
                value: 'home',
              },{
                label: '所有页面',
                value: 'all',
              }]"
              placeholder="动画展示位置"
            />
        </a-form-item>
        <a-form-item label="推荐标签" name="label" v-if="false">
            <Inputi18nInline  v-model:valid="batchCommonParams.label_i18n_valid" v-model:value="batchCommonParams.label" />
        </a-form-item>
        </div>
        
        <!-- 文件夹上传 -->
        <div style="margin: 10px;width: 800px;">
          <p class="form-section-title">文件夹上传</p>
          <a-form-item label="上传文件夹">
            <a-button type="primary" @click="handleFolderUpload">上传文件夹</a-button>
            <input 
              type="file" 
              ref="folderInput"
              style="display: none" 
              webkitdirectory 
              directory 
              @change="handleFolderChange"
            />
          </a-form-item>
          <!-- 批量模板配置 -->
          <p class="form-section-title">批量模板配置</p>
         
            <div v-if="batchTemplateData.length > 0">
              <div style="margin: 10px 0; font-weight: bold;">共 {{ batchTemplateData.length }} 个模板</div>
              <div style="display: grid; grid-template-columns: repeat(6, 1fr); gap: 15px; margin: 10px 0;">
                <div v-for="(template, index) in batchTemplateData" :key="template.id" style="min-width: 200px;padding: 10px; border: 1px solid #f0f0f0; border-radius: 4px; display: flex; flex-direction: column; align-items: center;">
                  <div style="text-align: center; font-size: 12px; margin-bottom: 5px;">模板 {{ index + 1 }}</div>
                    <a-form-item label="" style="margin-bottom: 10px;">
                      <Upload :file="template.file" v-model:imageUrl="template.image_url" />
                    </a-form-item>
                    <a-form-item label="" style="margin-bottom: 5px; width: 100%;">
                      <div>*后台名称</div>
                      <a-input size="small" placeholder="后台名称" v-model:value="template.title" />
                    </a-form-item>
                    <a-form-item label="" style="margin-bottom: 5px; width: 100%;">
                      <div>*标题(国际化)</div>
                      <Inputi18nInline  v-model:valid="template.name_i18n_valid" v-model:value="template.name" size="small" />
                    </a-form-item>
                    <a-form-item label="" style="margin-bottom: 0; width: 100%;">
                      <div>*排序</div>
                      <a-input  type="number" size="small" placeholder="排序" v-model:value="template.sorted" />
                      <div style="font-size: 10px; margin-top: 2px; color: #999;">*数字越大越靠前</div>
                    </a-form-item>
                     <div style="margin-top: 5px;">
                          <a-button danger  @click="handleDeleteTemplate(index)">删除模板</a-button>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <a-form-item label="">
              <a-button type="primary" @click="handleAddTemplate">+添加模板</a-button>
            </a-form-item>
        </div>

      <a-alert v-if="batchTemplateData.length == 0"  type="warning" message="请先上传文件夹" banner />
      <div style="margin: 20px 0; text-align: center;">
        <a-button type="primary" @click="handleBatchConfirm" :loading="loading">确认创建</a-button>
      </div>
      </a-form>
  </a-card>
</template>
<script>
import { defineComponent } from 'vue'
import { SearchOutlined } from '@ant-design/icons-vue';
import request from '@/utils/request'
import Upload from '@/components/Upload.vue'
import Inputi18nInline from '@/components/Inputi18nInline.vue'
import { Modal, message } from 'ant-design-vue';
import {  TaskStyleGroupOptions, SubTypeOptions,ToolIDOptions, ToolNames, StyleFlowNames, StyleNames, SubTypeNames,
  Operators,
   NationCodes} from '@/utils/macro'
import {generateRandomString} from '@/utils/string'

export default defineComponent({
  components: {
    Upload,
    Inputi18nInline,
    SearchOutlined,
  },
  data() {
    return {
      SubTypeOptions: SubTypeOptions,
      ToolIDOptions: ToolIDOptions,
      ToolNames: ToolNames,
      styleNames: StyleNames,
      NationCodes: NationCodes,
      subTypeNames: SubTypeNames,
      TaskStyleGroupOptions: TaskStyleGroupOptions,
      StyleFlowNames: StyleFlowNames,
      Operators: Operators,
      loading: false,
      batchCommonParams: {
        "tool_id": "",
        "style_id": "",
        "typeid": "",
        "category_id": "",
        "category_name": "",
        "version": "",
        "region_code": "CN",
        "prompt": "",
        "redirect_url": "",
        "cover_blind": "",
        "blind_position": "all",
        "label": "",
        "label_i18n_valid": false,
        "value": "",
        "spreadable": "0",
        "tab_id": "",
        "tab_name": "",
        "tab_sorted": "100",
        "sub_type": "",
      },
      batchTemplateData: [],
      folderUploadVisible: false,
      folderFiles: [],
      activeCollapseKey: ['1'],
      spreadableOptions: [
        {
          label: "无需",
          value: "0"
        },
        {
          label: "必须",
          value: "1"
        },
        {
          label: "可选",
          value: "2"
        }
      ],
      categoryOptions: [
        {
          label: "全身",
          value: "whole"
        },
        {
          label: "上装",
          value: "tops"
        },
        {
          label: "下装",
          value: "bottoms"
        }
      ],
    };
  },
  methods: {
    // 文件夹上传相关方法
    handleFolderUpload() {
      this.$refs.folderInput.click()
    },
    async handleFolderChange(e) {
      const files = e.target.files
      if (!files || files.length === 0) {
        return
      }
      
      // 过滤图片文件
      const imageFiles = Array.from(files).filter(file => {
        return file.type.startsWith('image/')
      })
      
      if (imageFiles.length === 0) {
        message.error('文件夹中没有图片文件')
        return
      }
      
      this.folderFiles = [...this.folderFiles, ...imageFiles]
      let basicStr = generateRandomString(9)
      // 生成模板数据
     for (let i = 0; i < imageFiles.length; i++) {
        const file = imageFiles[i]
        // 增加一点延迟，避免并发
        await new Promise(resolve => setTimeout(resolve, 50))
        
        try {
          // 创建模板数据
          const id = `${basicStr}-${i}`
          this.batchTemplateData.push({
            id: id,
            title: '',
            image_url: '', // 初始为空，等待用户使用 Upload 组件上传
            name: "template.title.batch_" + id,
            name_i18n_valid: false,
            sorted: 999, // 默认排序，从大到小
            file, // 自动上传
          })
        } catch (error) {
          message.error(`处理文件 ${file.name} 失败: ${error.message}`)
        }
      }
      
      message.success(`成功读取 ${imageFiles.length} 个图片文件，共 ${this.batchTemplateData.length} 个模板`)
    },
    // 添加单个模板
    handleAddTemplate() {
      const id = generateRandomString(10)
      // 创建新的模板数据
      this.batchTemplateData.push({
        id: id,
        title: '',
        image_url: '',
        name: "template.title.batch_" + id,
        name_i18n_valid: false,
        sorted: 999 // 默认排序，从大到小
      })
      message.success('已添加新模板')
    },
    // 删除单个模板
    handleDeleteTemplate(index) {
      this.batchTemplateData.splice(index, 1)
      message.success('模板已删除')
    },
    // 批量提交逻辑
    async handleBatchConfirm() {
      // 验证通用参数
      if (!this.batchCommonParams.tool_id) {
        message.error('请填写工具')
        return
      }
      if (!this.batchCommonParams.tab_id) {
         message.error('请选择归属 Tab，如果没展示请点击「加载Tab」')
        return
      }
      
      if (!this.batchCommonParams.style_id) {
         message.error('请选择工作流')
        return
      }
      if (this.batchTemplateData.length === 0) {
        message.error('请先上传文件夹并生成模板数据')
        return
      }
      
      // 验证每个模板的参数
      for (let i = 0; i < this.batchTemplateData.length; i++) {
        const template = this.batchTemplateData[i]
        if (!template.title) {
          message.error(`模板 ${i + 1} 请填写后台标题`)
          return
        }
        if (!template.name_i18n_valid) {
          message.error(`模板 ${i + 1} 表单展示文案不支持国际化，请补充国际化文案`)
          return
        }
        if (!template.image_url) {
          message.error(`模板 ${i + 1} 请上传封面(效果图)`)
          return
        }
      }
      
      this.loading = true
      
      try {
        // 批量提交数据
        let successCount = 0
        let failCount = 0
        
        for (let i = 0; i < this.batchTemplateData.length; i++) {
          const template = this.batchTemplateData[i]
          
          try {
            // 上传封面图
            let imageUrl = template.image_url
            let oriUrl = imageUrl // 封面和参考图默认一致
            
            // 组合数据
            const formData = {
              ...this.batchCommonParams,
              ...template,
              image_url: imageUrl.replace("http://statica.xuantu.pro/", ""),
              ori_url: oriUrl.replace("http://statica.xuantu.pro/", ""),
              sorted: +template.sorted,
              spreadable: +this.batchCommonParams.spreadable,
              tab_sorted: +this.batchCommonParams.tab_sorted
            }
            
            // 如果推荐标签为空，删除推荐标签的 i18n 文案
            if (!this.batchCommonParams.label_i18n_valid) {
              formData.label = ""
            }
            
            if (this.batchCommonParams.position) {
              formData.value = JSON.stringify({
                position: this.batchCommonParams.position
              })
            }
            
            // 提交单个模板
            const resp = await request.post('/api/creation/options', formData)
            if (resp.code === 0) {
              successCount++
            } else {
              failCount++
              console.error(`处理模板 ${i + 1} 失败: ${resp.message}`)
              message.error(`处理模板 ${i + 1} 失败: ${resp.message}`)
            }
          } catch (error) {
            failCount++
            console.error(`处理模板 ${i + 1} 失败: ${error.message}`)
            message.error(`处理模板 ${i + 1} 失败: ${error.message}`)
          }
        }
        
        message.success(`批量创建成功 ${successCount} 个模板，失败 ${failCount} 个`)
        if (successCount > 0 ) {
            this.$router.push('/home/creation/options')
        } 
      } catch (error) {
        message.error(`批量创建失败: ${error.message}`)
      } finally {
        this.loading = false
      }
    },
    // 批量加载 Tab
    async getBatchOptionTabs(){
      if (this.batchCommonParams.tool_id == "" || this.batchCommonParams.region_code == "" ) {
        message.error('请选择工具类型、地区')
        return
      }
      let resp = await request.get('/api/creation/option_tabs', {
        tool_id: this.batchCommonParams.tool_id,
        limit: 999,
      })
      this.optionTabs = []
      if (resp.data.list) {
        for(let v of resp.data.list) {
          this.optionTabs.push({
            label: v.tab_name,
            value: v.id,
          })
        }
      }
      if (this.optionTabs.length > 0 && this.batchCommonParams.tab_id == "") {
        this.batchCommonParams.tab_id = this.optionTabs[0].value
      }
    },
    // 批量搜索 Tab
    async searchBatchOptionTabs(){
      window.open(`/home/creation/tabs?tool_id=${this.batchCommonParams.tool_id}&sub_type=${this.batchCommonParams.sub_type}&region_code=${this.batchCommonParams.region_code}`, '_blank')
    },
  },
  setup(props, context) {
    return {
      optionTabs: [],
    };
  },
})
</script>

<style scoped>

</style>